
import { Component, Vue } from 'vue-property-decorator'
import IconBox from '@/components/container/IconBox.vue'
import { IconDataSpan } from 'ui-library'
import i18n from '@/i18n'
import { getIdLevel } from '@/utils/KeycloakUtils'

@Component({
  i18n,
  components: {
    IconBox
  }
})
export default class SettingsIconBox extends Vue {
  private changePasswordUrl: string = window.ENV_CONFIG.SERVICE_LINKS.SETTINGS_PAGE.CHANGE_PASSWORD_PAGE
  private changeEmailUrl: string = window.ENV_CONFIG.SERVICE_LINKS.SETTINGS_PAGE.CHANGE_EMAIL_PAGE
  private changeServiceCodeInputUrl: string = window.ENV_CONFIG.SERVICE_LINKS.SETTINGS_PAGE.CHANGE_SERVICECODEINPUT_PAGE
  private changeServiceCodeRequestUrl: string =
    window.ENV_CONFIG.SERVICE_LINKS.SETTINGS_PAGE.CHANGE_SERVICECODEREQUEST_PAGE

  get showFreischaltCodeIcons(): boolean {
    return getIdLevel() === 0
  }

  get settingsIconList(): IconDataSpan[] {
    const changePasswordIcon: IconDataSpan = {
      href: this.changePasswordUrl,
      iconClass: 'passwort',
      label: this.$t('settingsIcons.changePassword').toString()
    }

    const changeEmailIcon: IconDataSpan = {
      href: this.changeEmailUrl,
      iconClass: 'at-zeichen',
      label: this.$t('settingsIcons.changeEmail').toString()
    }

    const inputServiceCodeIcon: IconDataSpan = {
      href: this.changeServiceCodeInputUrl,
      iconClass: 'servicecode',
      label: this.$t('settingsIcons.serviceCode').toString()
    }

    const inputServiceCodeRequestIcon: IconDataSpan = {
      href: this.changeServiceCodeRequestUrl,
      iconClass: 'freischaltcode_anfordern',
      label: this.$t('settingsIcons.serviceCodeRequest').toString()
    }

    const iconList = [changePasswordIcon, changeEmailIcon]
    if (this.showFreischaltCodeIcons) {
      iconList.push(inputServiceCodeIcon, inputServiceCodeRequestIcon)
    }
    return iconList
  }
}
